<template>
    <div class="bean-button" v-bind:class="{ active:active }">
        <a @click.prevent="addBean" href="" class="button" v-bind:class="[buttonClass,color]" v-html="active ? unselect : select"></a>
    </div>
</template>

<script>
    module.exports = {
        data:function() {
            return {
                active:false
            }
        },
        props: {
            buttonClass:{type:String,default:'pill small'},
            color:{type:String,default:'green-secondary'},
            select:{type:String,default:'Select Bean'},
            unselect:{type:String,default:'Unselect'},
            bean:{type:Object},
            selected:{type:Array,default:function() { return [] }}
        },
        watch: {
            selected:function() {
                this.active = this.isSelected();
            }
        },
        methods: {
            isSelected:function() {
                var isSelected = false;
                var e = this;
                $.each(this.selected,function(index,bean) {
                    if(bean.id == e.bean.id) {
                        isSelected = true;
                    }
                });
                return isSelected;
            },
            addBean:function() {
                var pushNew = this.isSelected() ? false : true;
                var e = this;
                if(pushNew) {
                    this.$setProjectBean(this.bean);
                    this.active = true;
                } else {
                    this.active = false;
                    $.each(this.$getProjectBeans(),function(index,bean) {
                        if(bean != undefined) {
                            if (bean.id == e.bean.id) {
                                e.$removeProjectBean(index);
                            }
                        }
                    });
                }
            }
        },
        mounted:function() {
            this.active = this.isSelected();
        }
    }
</script>
